import React from 'react';
import { Grid } from '@material-ui/core';
import FutureTasks from './FutureTasks';
import AboutUs from './AboutUs';
import LastOrders from './LastOrders';
import BestSellers from './BestSellers';


const Dashboard = () => {
  return (
    <div>
      <Grid container spacing={2}>
        <Grid item sm={12} md={6} xs={12}>
          <FutureTasks />
        </Grid>
      </Grid>
      <Grid container spacing={0}>
        <AboutUs />
      </Grid>
      <Grid container spacing={0}>
        <Grid item sm={12} md={6} xs={12}>
          <LastOrders />
        </Grid>
        <Grid item sm={12} md={6} xs={12}>
          <BestSellers />
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
